export const leaveHistoryConstants = {
    GET_LIST_SUCCESS: "GET_LIST_SUCCESS",
    GET_LIST: "GET_LIST",
    CLEAR_LOADING: "CLEAR_LOADING"
};
